// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file company/v1/company.proto (package company.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { User } from "../../base/v1/user_pb.js";
import { AccessType } from "../../base/v1/access_pb.js";

/**
 * @generated from message company.v1.Company
 */
export const Company = /*@__PURE__*/ proto3.makeMessageType(
  "company.v1.Company",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "users", kind: "message", T: CompanyUser, repeated: true },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
    { no: 5, name: "updated_at", kind: "message", T: Timestamp },
    { no: 6, name: "common_complaint_types", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "individual_complaint_types", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message company.v1.CompanyUser
 */
export const CompanyUser = /*@__PURE__*/ proto3.makeMessageType(
  "company.v1.CompanyUser",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
    { no: 2, name: "access_type", kind: "enum", T: proto3.getEnumType(AccessType) },
  ],
);

